"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexOfNextCommaOutsideParentesis = void 0;
function indexOfNextCommaOutsideParentesis(str) {
    for (var i = 0, ch = "", nOpen = 0, nBrackets = 0; i < str.length; i++) {
        ch = str[i];
        if (ch === "(")
            nOpen++;
        else if (ch === ")")
            nOpen--;
        else if (ch === "[")
            nBrackets++;
        else if (ch === "]")
            nBrackets--;
        else if (ch === "," &&
            nOpen <= 0 &&
            nBrackets <= 0)
            return i;
    }
    return -1;
}
exports.indexOfNextCommaOutsideParentesis = indexOfNextCommaOutsideParentesis;
